import { useCallback, useState } from 'react'

/**
 * Keyset pagination state for `{ items, next_cursor }` lists: a stack of cursors so
 * "Previous" returns to the exact page the user saw. `reset` on filter changes.
 */
export function useCursorPager() {
  const [stack, setStack] = useState<(string | null)[]>([null])
  const cursor = stack[stack.length - 1] ?? null
  const next = useCallback((nextCursor: string | null) => {
    if (nextCursor) setStack((current) => [...current, nextCursor])
  }, [])
  const previous = useCallback(() => {
    setStack((current) => (current.length > 1 ? current.slice(0, -1) : current))
  }, [])
  const reset = useCallback(() => setStack([null]), [])
  return { cursor, page: stack.length, hasPrevious: stack.length > 1, next, previous, reset }
}
